module.exports = __webpack_public_path__ + "img/aParty_042724_E.3a4ed921.jpg";